<template>
  <b-button
    class="btn mb-4"
    variant="tertiary"
    @click="$emit('click')"
    v-if="canCreateActionPlan"
  >
    <i class="material-icons mr-1">add_circle</i>
    <span class="d-lg-inline-block">
      {{ labelNewActionPlan }}
    </span>
  </b-button>
</template>

<script>
import { isManager } from '@/service/user'
import { mapGetters } from 'vuex'

const props = {
  groupId: {
    type: String,
    required: false,
    default: 'company',
  },
}
export default {
  props,

  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labelNewActionPlan() {
      return this.resources.page.reports.engagement.overall.actionPlan
    },
    canCreateActionPlan() {
      const isCompany = groupId => groupId === 'company'
      const defaultPermission = () => this.$can('create', 'actionPlan')
      const isManagerOnCompanyView = () =>
        isManager() && isCompany(this.groupId)
      return isManagerOnCompanyView() ? false : defaultPermission()
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  align-items: center;
  display: inline-flex;
}
</style>
